// AddEditSessionModal.jsx

import React, { useEffect, useState } from "react";

import "./ProviderTracking.css";

import { toast } from "react-toastify";

import {
  addProviderTrackingSession,
  updateProviderTrackingSession,
} from "../../config/LiveApi";

const AddEditSessionModal = ({
  selectedId,
  sessionData,
  isEdit = false,
  onClose,
  onSuccess,
}) => {
  const [formData, setFormData] =
    useState({
      startDate: "",
      endDate: "",
      remark: "",
    });

  const [loading, setLoading] =
    useState(false);

  useEffect(() => {
    if (isEdit && sessionData) {
      setFormData({
        startDate:
          sessionData?.startDate
            ?.split("T")[0] || "",

        endDate:
          sessionData?.endDate
            ?.split("T")[0] || "",

        remark:
          sessionData?.remark || "",
      });
    }
  }, [isEdit, sessionData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      if (isEdit) {
        await updateProviderTrackingSession(
          selectedId,
          {
            oldStartDate:
              sessionData?.startDate,

            startDate:
              formData?.startDate,

            endDate:
              formData?.endDate ||
              null,

            remark:
              formData?.remark,
          },
        );

        toast.success(
          "Session updated successfully",
        );
      } else {
        await addProviderTrackingSession(
          selectedId,
          {
            startDate:
              formData?.startDate,

            endDate:
              formData?.endDate ||
              null,

            remark:
              formData?.remark,
          },
        );

        toast.success(
          "Session added successfully",
        );
      }

      onSuccess();

      onClose();
    } catch (error) {
        console.error("Failed to update session", error);
      toast.error(
        isEdit
          ? "Failed to update session"
          : "Failed to add session",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="provider-tracking-modal-overlay">
      <div className="provider-tracking-modal">
        <div className="provider-tracking-modal-header">
          <h3>
            {isEdit
              ? "Update Session"
              : "Add Session"}
          </h3>

          <button onClick={onClose}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="provider-tracking-form-group">
            <label>
              Start Date
            </label>

            <input
              type="date"
              name="startDate"
              value={
                formData?.startDate
              }
              onChange={
                handleChange
              }
              required
            />
          </div>

          <div className="provider-tracking-form-group">
            <label>
              End Date
            </label>

            <input
              type="date"
              name="endDate"
              value={
                formData?.endDate
              }
              onChange={
                handleChange
              }
            />
          </div>

          <div className="provider-tracking-form-group">
            <label>Remark</label>

            <textarea
              name="remark"
              value={
                formData?.remark
              }
              onChange={
                handleChange
              }
              placeholder="Enter remark..."
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="provider-tracking-submit-btn"
          >
            {loading
              ? "Please wait..."
              : isEdit
              ? "Update Session"
              : "Add Session"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddEditSessionModal;